import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white font-sans" data-id="element-0">
      <Header data-id="element-1" />
      <main className="max-w-5xl mx-auto px-5 sm:px-6 md:px-8" data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <Solution data-id="element-5" />
        <Benefits data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Offer data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}